'use client';

import React from 'react';
import ThemeProvider from './ThemeToggle/theme-provider';
import { TooltipProvider } from '@/components/ui/tooltip';
import { SWRProvider } from '@/components/providers/swr-provider';

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <>
      <ThemeProvider attribute='class' defaultTheme='system' enableSystem>
        <SWRProvider>
          <TooltipProvider>{children}</TooltipProvider>
        </SWRProvider>
      </ThemeProvider>
    </>
  );
}
